// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cdf02475","239":"334f961b","455":"1e605bde"}[chunkId] + ".chunk.js";
};